/**
 * Giriş gerektirmeyen paylaşım raporlarının gizli adresleri — TEK KAYNAK.
 * App.js'teki rota da, sayfanın veri çektiği uç da bu sabitten türetilir.
 *
 * Slug rastgele 128 bit: adres tahmin edilerek bulunamaz. Bu bir ERİŞİM DENETİMİ
 * DEĞİL, sadece gizlilik — linke sahip olan herkes veriyi görür.
 *
 * Slug değiştirmek (link yakmak) için: buradaki değeri değiştir + backend'de
 * glowytics-backend/src/routes/publicReports.js içindeki AYNI İSİMLİ sabiti
 * (HIGH5_NET_SALES_SLUG, WUNDER_BIRKENSTOCK_SLUG …) aynı değerle güncelle,
 * sonra backend'i yeniden başlat. İkisi tutmazsa sayfa açılır ama veri gelmez.
 */
export const HIGH5_NET_SALES_SLUG = '6a4f220db30a84aa4f5e0b94409ea7cb';

export const HIGH5_NET_SALES_PATH = `/p/${HIGH5_NET_SALES_SLUG}`;

/** Wunder × Birkenstock — Meta etkileşim kampanyası + ikas günlük satış raporu. */
export const WUNDER_BIRKENSTOCK_SLUG = '55c850b302348485e56ee5704f15db85';

export const WUNDER_BIRKENSTOCK_PATH = `/p/${WUNDER_BIRKENSTOCK_SLUG}`;

/**
 * Yataş Grup · AI Visibility — yalnız AI Visibility sayfası, sidebar yok (25 Eyl 2026).
 * Backend karşılığı: glowytics-backend/src/routes/aiVisibility.js → PUBLIC_LINKS
 * (anahtar AYNI değer olmalı). Veri /api/ai-visibility/public/<slug>/… uçlarından.
 */
export const YATAS_AI_VISIBILITY_SLUG = '5964761575b3f1ddbedd00da4b585736';

export const YATAS_AI_VISIBILITY_PATH = `/p/${YATAS_AI_VISIBILITY_SLUG}`;

/**
 * High5 · Mobil × masaüstü dönüşüm analizi (Eylül 2026) — statik rapor, veri sayfaya gömülü.
 * Backend karşılığı YOK (uç çağrılmıyor); link yakmak için yalnız bu değeri değiştir.
 */
export const HIGH5_MOBIL_DONUSUM_SLUG = '94335ee294681b26a69f23c700e2dce7';

export const HIGH5_MOBIL_DONUSUM_PATH = `/p/${HIGH5_MOBIL_DONUSUM_SLUG}`;
